import mitt, { Emitter } from "mitt";
import {
    BasketPayload,
    EntryPayload,
    FilterSection,
    Product,
    ProductProductVariation,
    UpsellBasketPayload,
} from "@daalder/types";
import OpenQuoteModalProps from "../types/OpenQuoteModalProps";

/**
 * @deprecated This should be removed and replaced with Pinia stores and such.
 */
export type Events = {
    AfterProductPayloadCalculated: EntryPayload[];
    openQuoteModal: OpenQuoteModalProps;
    filtersChanged: any[];
    aggregationsFetched: FilterSection[];
    clearFilter: { id: number | string; value: string };
    clearAllFilters: void;
    addToWishList: {
        productIds: number[];
    };
    openLimitedStockModal: any;
    baseProductAmountChanged: number;
};

/**
 * @deprecated Get rid of this. All these events should be refactored to Pinia method calls.
 */
const ProductEventBus: Emitter<Events> = mitt<Events>();

export default ProductEventBus;
